var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBestOrder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2303 11.0785C20.2019 10.9583 20.1443 10.8469 20.0625 10.7544C19.9807 10.6618 19.8774 10.5908 19.7616 10.5478L14.3607 8.5219L15.735 1.64721C15.7662 1.48748 15.7445 1.32197 15.6733 1.17564C15.6021 1.0293 15.4852 0.910102 15.3403 0.836016C15.1954 0.76193 15.0304 0.73698 14.8701 0.764931C14.7097 0.792882 14.5629 0.872217 14.4516 0.990965L3.95159 12.241C3.86631 12.3308 3.80462 12.4404 3.77203 12.5599C3.73943 12.6795 3.73696 12.8052 3.76481 12.9259C3.79267 13.0466 3.84999 13.1585 3.93166 13.2517C4.01334 13.3448 4.11681 13.4163 4.23284 13.4597L9.63566 15.4857L8.26503 22.3528C8.23391 22.5126 8.25558 22.6781 8.32679 22.8244C8.39799 22.9708 8.51485 23.09 8.65974 23.164C8.80464 23.2381 8.96969 23.2631 9.13001 23.2351C9.29032 23.2072 9.4372 23.1278 9.54847 23.0091L20.0485 11.7591C20.1322 11.6692 20.1926 11.5601 20.2243 11.4415C20.256 11.3228 20.2581 11.1981 20.2303 11.0785ZM10.2535 20.0625L11.235 15.1519C11.2702 14.9777 11.2423 14.7968 11.1565 14.6412C11.0706 14.4857 10.9324 14.3656 10.7663 14.3025L5.81253 12.4416L13.7457 3.94221L12.765 8.85284C12.7299 9.027 12.7577 9.20797 12.8436 9.36352C12.9294 9.51907 13.0677 9.6391 13.2338 9.70222L18.1838 11.5585L10.2535 20.0625Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestOrder);
export default __webpack_public_path__ + "static/media/best-order.f12417a4a096b4bcfaf1e6d5c2a81ccc.svg";
export { ForwardRef as ReactComponent };